module.exports = __webpack_public_path__ + "img/Philippines-3.dd4549fc.jpg";